import { Flexbox } from "@profiler/ui";

import { CONTENT_HEIGHT } from "../constants";
import { Sidebar } from "./Sidebar";
import { MonacoEditor } from "./MonacoEditor";
import { ResultViewer } from "./ResultViewer";
import { TopBar } from "./TopBar";

export const Content = () => {
  return (
    <Flexbox
      flexFlow="row nowrap"
      justifyContent="center"
      alignItems="flex-start"
    >
      <Sidebar />
      <Flexbox flexFlow="column" width={"100%"}>
        <TopBar />
        <Flexbox
          flexGrow={1}
          color="text"
          bg="base"
          minHeight={CONTENT_HEIGHT}
          maxHeight={CONTENT_HEIGHT}
        >
          <MonacoEditor />
          <ResultViewer />
        </Flexbox>
      </Flexbox>
    </Flexbox>
  );
};
